import PDFAcroTerminal from "./PDFAcroTerminal";
class PDFAcroSignature extends PDFAcroTerminal {
}
PDFAcroSignature.fromDict = (dict, ref) => new PDFAcroSignature(dict, ref);
export default PDFAcroSignature;
//# sourceMappingURL=PDFAcroSignature.js.map